import { parseMarkdownMentions } from '@aline/common';

import type { MentionEntityIds } from './useMentionEntitiesQuery';
import { createEmptyMentionEntityIds } from './useMentionEntitiesQuery';

export function createMentionEntityIdSets() {
  return {
    documentIds: new Set<string>(),
    playbookIds: new Set<string>(),
    playbookRuleIds: new Set<string>(),
    reportIds: new Set<string>(),
    skillVersionIds: new Set<string>(),
    taskIds: new Set<string>(),
    workflowIds: new Set<string>(),
  };
}

export function addMentionEntityIdsFromMarkdown(
  allIds: ReturnType<typeof createMentionEntityIdSets>,
  markdown: string | null | undefined
) {
  if (!markdown) return;

  for (const mention of parseMarkdownMentions(markdown)) {
    switch (mention.type) {
      case 'document':
      case 'selection':
      case 'selection-v2':
      case 'selection-v3':
        allIds.documentIds.add(mention.id);
        break;
      case 'report':
        allIds.reportIds.add(mention.id);
        break;
      case 'playbook':
        allIds.playbookIds.add(mention.id);
        break;
      case 'playbook-rule':
        allIds.playbookRuleIds.add(mention.id);
        break;
      case 'task':
        allIds.taskIds.add(mention.id);
        break;
      case 'workflow':
        allIds.workflowIds.add(mention.id);
        break;
      case 'intake-form':
      case 'party':
      case 'user':
        break;
    }
  }
}

export function toMentionEntityIds(
  ids: ReturnType<typeof createMentionEntityIdSets>
): MentionEntityIds {
  const emptyIds = createEmptyMentionEntityIds();

  return {
    ...emptyIds,
    documentIds: [...ids.documentIds],
    playbookIds: [...ids.playbookIds],
    playbookRuleIds: [...ids.playbookRuleIds],
    reportIds: [...ids.reportIds],
    skillVersionIds: [...ids.skillVersionIds],
    taskIds: [...ids.taskIds],
    workflowIds: [...ids.workflowIds],
  };
}
